import { useQuery } from "@apollo/react-hooks";
import { IEventGraphQL } from "@sellout/models/.dist/interfaces/IEvent";
import LIST_EVENTS_OPTIMIZED from "@sellout/models/.dist/graphql/queries/eventsListOptimized.query";
import { QueryHookOptions } from "@apollo/react-hooks";

type UseListEventsOptimized = {
  events: IEventGraphQL[] | undefined;
  loading: boolean;
  error: any | undefined;
  fetchMore: Function | undefined;
  refetch: Function;
};

type UseListEventsOptimizedHook = (params?: QueryHookOptions) => UseListEventsOptimized;

const useListEventsOptimizedHook: UseListEventsOptimizedHook = (params) => {
  
  const { data, loading, error, refetch, fetchMore } = useQuery(LIST_EVENTS_OPTIMIZED, {
    ...params,
    fetchPolicy: "network-only",
  });

  return {
    events: data?.events,
    loading,
    error,
    refetch,
    fetchMore,
  };
};

export default useListEventsOptimizedHook;
